import { apiClient } from "../../../lib";

export const projectDetailsApi = {

    fetchProjectDetails: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}`);
        return response.data;
    },

    fetchProjectStats: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/stats`);
        return response.data;
    },
    fetchProjectCostTrend: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/cost-trend`);
        return response.data;
    },
    fetchProjectPhases: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/phases`);
        return response.data;
    },
    fetchProjectRagStatus: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/rag-status`);
        return response.data;
    },
    fetchProjectStageGates: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/stage-gate`);
        return response.data;
    },

    // Asset APIs
    fetchProjectAssets: async (projectId?: string, page?: number, limit?: number): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/asset`, { params: { page, limit } });
        return response.data;
    },
    createAsset: async ({ projectId, assetData }: { projectId: string, assetData: any }): Promise<any> => {
        const response = await apiClient.post(`/projects/${projectId}/asset`, assetData);
        return response.data;
    },
    updateAsset: async ({ projectId, assetId, assetData }: { projectId: string, assetId: number, assetData: any }): Promise<any> => {
        const response = await apiClient.put(`/projects/${projectId}/asset/${assetId}`, assetData);
        return response.data;
    },
    deleteAsset: async ({ projectId, assetId }: { projectId: string | undefined, assetId: number }): Promise<any> => {
        const response = await apiClient.delete(`/projects/${projectId}/asset/${assetId}`);
        return response.data;
    },

    // StakeHolder APIs
    fetchProjectStakeHolderDetails: async ({ projectId, page, limit }: { projectId?: string; page?: number; limit?: number }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/stake-holders`, { params: { page, limit } });
        return response.data;
    },
    createStakeHolder: async ({ projectId, stakeHolderData }: { projectId: string | undefined, stakeHolderData: any }): Promise<any> => {
        const response = await apiClient.post(`/projects/${projectId}/stake-holders`, stakeHolderData);
        return response.data;
    },
    deleteStakeHolder: async ({ projectId, stakeHolderId }: { projectId: string | undefined, stakeHolderId: number }): Promise<any> => {
        const response = await apiClient.delete(`/projects/${projectId}/stake-holders/${stakeHolderId}`);
        return response.data;
    },
    fetchStakeHolderOwnership: async ({ projectId, userId }: { projectId: string | undefined; userId: number }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/stake-holder-ownership/${userId}`)
        return response.data;
    },

    fetchProjectActivityList: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(`/contractor/activity-list?project_id=${projectId}`);
        return response.data;
    },
};